export const state = {
    loading: false,
};

export const getters = {
    getLoadingStatus: (state) => state.loading,
};

export const mutations = {
    ['SET_LOADING'](state, value) {
        state.loading = value;
    },
};

export const actions = {
    changeLoadingStatus({ commit }, value) {
        commit('SET_LOADING', value);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
